export default {"src":"/_next/static/media/delete-product.70934ffc.svg","height":42,"width":42,"blurWidth":0,"blurHeight":0};